"use client";

import dynamic from "next/dynamic";

import type { BlockIntegrationsGridClientProps } from "./BlockIntegrationsGridClient";

const BlockIntegrationsGridClient = dynamic(() =>
  import("./BlockIntegrationsGridClient").then(mod => mod.BlockIntegrationsGridClient),
);

export function BlockIntegrationsGridWrapper(props: BlockIntegrationsGridClientProps) {
  return <BlockIntegrationsGridClient {...props} />;
}
